export default "__VITE_ASSET__CztLW4Wm__"